import type { FC } from 'react';

import { CardType } from '@shared/cards-types';

import { AuthorizedCardType } from './AuthorizedCardType';
import { CardTypeView } from './CardTypeView';

interface Props {
    productId?: string;
    transactionCardId: string;
    transactionCardType: CardType;
}

export const CardTypeContainer: FC<Props> = ({
    productId,
    transactionCardId,
    transactionCardType,
}) => {
    if (productId && transactionCardType === CardType.ADDITIONAL) {
        return (
            <AuthorizedCardType
                productId={productId}
                transactionCardId={transactionCardId}
                transactionCardType={transactionCardType}
            />
        );
    }

    return <CardTypeView cardType={transactionCardType} />;
};
